export default __webpack_public_path__ + "static/carousel-deliver-d738955bf0e3db70a4da56f36d5a111e.svg";